import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';

import Content from '../components/Content';
import UiValidate from '../../../components/forms/validation/UiValidate';
import { resetPassword } from '../../../store/auth/AuthActions';
import { domainName, hostTitle } from '../../../config/ui';

const validationOptions = {
  rules: {
    email: {
      required: true,
      email: true,
    }
  },

  // Messages for form validation
  messages: {
    email: {
      required: 'Please enter your email address',
      email: 'Please enter a VALID email address',
    }
  },
};
class Forgot extends React.Component {
  onSubmit(e) {
    e.preventDefault();

    const $form = $(this.refs.forgotForm);
    const $email = $(this.refs.email);

    if ($form.data('validator')) {
      if ($form.valid()) {
        this.props.resetPassword($email.val()).then(
          (response) => {
            toast.success('If the email address is registered, you will receive a password reset link.');
          },
          () => toast.error("Something went wrong. Please try again later."));
      }
    }
  }
  render() {
    const { auth } = this.props;

    return (
      <div id="extr-page">
        <Helmet title={`Forgot Password? – ${hostTitle()}`} />
        <header id="header" className="animated fadeInDown">
          <div id="logo-group">
            <span id="logo">
              {' '}
              <img src={`assets/img/${domainName()}logo.png`} alt="SmartAdmin" />{' '}
            </span>
          </div>

          <span id="extr-page-header-space">
            {' '}
            <span className="hidden-mobile hiddex-xs">
              Need an account?
            </span>{' '}
            <a href="#/register" className="btn btn-danger">
              Create account
            </a>{' '}
          </span>
        </header>
        <div id="main" role="main" className="animated fadeInDown">
          <div id="content" className="container">
            <div className="row">
              <Content className="col-xs-12 col-sm-12 col-md-7 col-lg-8 hidden-xs hidden-sm" />
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4">
                <div className="well no-padding">
                  <UiValidate options={validationOptions}>
                  <form
                    id="login-form"
                    ref="forgotForm"
                    className="smart-form client-form"
                    noValidate="novalidate"
                    onSubmit={this.onSubmit.bind(this)}
                  >
                    <header>Forgot Password</header>

                    <fieldset>
                      <section>
                        <label className="label">
                          Enter your email address
                        </label>
                        <label className="input">
                          {' '}
                          <i className="icon-append fa fa-envelope" />
                          <input type="email" name="email" ref="email" />
                          <b className="tooltip tooltip-top-right">
                            <i className="fa fa-envelope txt-color-teal" />{' '}
                            Please enter email address for password reset
                          </b>
                        </label>
                        <div className="note">
                          <a href="#/login">I remembered my password!</a>
                        </div>
                      </section>
                    </fieldset>
                    <footer>
                      <button className="btn btn-primary">
                        <i className="fa fa-refresh" /> Reset Password
                      </button>
                    </footer>
                    {auth.isLoading &&
                      <div className="cover">
                        <div className="spinner inline"></div>
                      </div>
                    }
                  </form>
                  </UiValidate>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  }
}

export default connect(
  state => ({ auth: state.auth }),
  dispatch => ({
    resetPassword: email => dispatch(resetPassword(email)),
  }),
)(Forgot);



// WEBPACK FOOTER //
// ./src/routes/auth/containers/Forgot.js